//Componentes generales
import { useContext, useState,useEffect } from 'react';
import StyledNavbar_top from '../navbar/StyledNavbar_top';
import StyledNavbar_bottom from '../navbar/StyledNavbar_bottom';
import Error404 from '../error404/Error404';

//Contexto para validacion de inicio de sesion
import authContext from '../../context/authentication/authContex';
import { color } from '@mui/system';
import { Tune } from '@mui/icons-material';

/* 
  Componente encargado de hacer permanentes las barras de navegación top y bottom, lo unico que se actualiza es lo del medio.
      Donde children es el componente que puede cambiar.
            section es el titulo de la sección es que esta posicionado.
*/
const Home = ({children, section}) => {

  //Context auth
  const aContext = useContext(authContext);
  const { usuario, showTuto } = aContext;

  if(usuario){
    return (
      <div 
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          //  backgroundColor:'#3D4D87'
        }}>
        <StyledNavbar_top section={section}/>

        <div style={{ flex: 1 , flexGrow: 1, overflow: "hidden"}}>
          {children}
        </div> 

        <StyledNavbar_bottom usuario={usuario} showTuto={showTuto}/>

      </div>
    );
  }else{
    //Se agrega timeout para que no arroje la vista Error404 al abrir una nueva ventana con window.open.
    setTimeout(()=>{
      return (
        <div><Error404/></div>
      )
    },3000)
   
  }
};
export default Home;
